import { OCCASIONS, RECIPIENTS, VIBES } from "../../data/presents";
import type { DisabledOptions, OptionGroup } from "../../lib/siteSettings";
import { useGiftCatalog } from "../../lib/giftCatalog";

const GROUPS: { key: OptionGroup; title: string; options: { id: string; label: string }[] }[] = [
  { key: "recipients", title: "Recipient", options: RECIPIENTS },
  { key: "vibes", title: "Vibe / personality", options: VIBES },
  { key: "occasions", title: "Occasion", options: OCCASIONS },
];

export function FilterOptionToggles({ value, onChange }: { value: DisabledOptions; onChange: (v: DisabledOptions) => void }) {
  const { gifts } = useGiftCatalog();
  const count = (g: OptionGroup, id: string) => gifts?.filter((x) => (x[g] || []).includes(id)).length;
  const flip = (g: OptionGroup, id: string, total: number) => {
    const off = value[g].includes(id) ? value[g].filter((x) => x !== id) : [...value[g], id];
    if (g !== "occasions" && off.length >= total) return;
    onChange({ ...value, [g]: off });
  };
  return (
    <div className="mt-3 border-t-2 border-dashed border-[#F2D9B8] pt-2" data-testid="admin-filter-toggles">
      <p className="text-[11px] font-extrabold uppercase tracking-wide text-[#6b3a12]">Gift finder options — tap to switch on/off (hides from public menus only; gift tags are untouched)</p>
      {GROUPS.map((grp) => (
        <div key={grp.key} className="mt-2">
          <p className="text-xs font-bold text-ink">{grp.title}</p>
          <div className="mt-1 flex flex-wrap gap-1.5">
            {grp.options.map((o) => {
              const on = !value[grp.key].includes(o.id);
              const n = count(grp.key, o.id);
              return (
                <button key={o.id} type="button" aria-pressed={on} onClick={() => flip(grp.key, o.id, grp.options.length)}
                  className={`rounded-full border-2 px-2.5 py-0.5 text-xs font-extrabold transition-colors ${on ? "border-[#1a1006] bg-[#FFE14D] text-[#1a1006]" : "border-[#c9b79c] bg-white text-[#a08b6d] line-through"}`}
                  data-testid={`admin-toggle-${grp.key}-${o.id}`} data-state={on ? "on" : "off"}>
                  {o.label}
                  {n != null && <span className={`ml-1 inline-block rounded-full px-1.5 text-[10px] no-underline ${n === 0 ? "bg-[#C8102E] text-white" : "bg-white/70 text-[#6b3a12]"}`} data-testid={`admin-count-${grp.key}-${o.id}`}>{n}</span>}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
